import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { clearError } from '../actions/environment';

import ErrorModal from '../components/Common/ErrorModal';

class ErrorModalContainer extends Component {
    render() {
        return (
            <ErrorModal { ...this.props } />
        );
    }
}

function mapStateToProps(state) {
    const { error } = state.environment;

    return {
        error,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ clearError }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModalContainer);



// WEBPACK FOOTER //
// ./scripts/containers/ErrorModalContainer.jsx